class InteractionManager {
	constructor() {
		this.interactableGroupAreaArray = [];
		this.cursorStyleGroupAreaArray = [];
		this.interactableMainAreaArray = [];
		this.cursorStyleMainAreaArray = [];
		this.itemDataArray = [];
		this.groupDataArray = [];
	}

	clearGroupSection() {
		this.interactableGroupAreaArray = [];
		this.cursorStyleGroupAreaArray = [];
		this.groupDataArray = [];
	}
	clearMainSection() {
		this.interactableMainAreaArray = [];
		this.cursorStyleMainAreaArray = [];
		this.itemDataArray = [];
	}

	getDataAtPosition(x, y) {
		return {
			cursorData: this.cursorStyleGroupAreaArray.concat(this.cursorStyleMainAreaArray).find(area => {
				return x >= area.x && x < area.x + area.width && y >= area.y && y < area.y + area.height;
			}),
			itemData: this.itemDataArray.find(itemData => {
				const horizontalExtension = (itemData.item && itemData.item.horizontalExtension) || 0;
				return x >= itemData.x && x < itemData.x + itemData.width + horizontalExtension && y >= itemData.y && y < itemData.y + itemData.height;
			}),
			groupData: this.groupDataArray.find(groupData => {
				return y >= groupData.y && y < groupData.y + groupData.height;
			}),
		};
	}

	addItem(item, x, y, width, height) {
		this.itemDataArray.push({item, x, y, width, height});
	}

	addGroup(group, y, height) {
		this.groupDataArray.push({group, y, height});
	}

	/*
	 * The priority parameter should be a number. A higher number means a higher priority.
	 */
	addInteractableArea(x, y, width, height, event, handler, priority, isGroupSection = false) {
		(isGroupSection ? this.interactableGroupAreaArray : this.interactableMainAreaArray).push({x, y, width, height, event, handler, priority});
	}

	addCursorStyleArea(x, y, width, height, cursorStyle, isGroupSection = false) {
		(isGroupSection ? this.cursorStyleGroupAreaArray : this.cursorStyleMainAreaArray).push({x, y, width, height, cursorStyle});
	}
}

export const interactionManager = new InteractionManager();
